var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rot-main"},[_c('Tabulator',{attrs:{"tableID":"rotTable","tableData":_vm.data['data'],"tableTitle":"ROTs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }